var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "loader-btn btn", class: _vm.rootClasses },
    [
      _c("dot-loader", {
        staticClass: "loader-btn--loader",
        attrs: { "is-active": _vm.isLoading }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "loader-btn--content" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1845134a", { render: render, staticRenderFns: staticRenderFns })
  }
}